import { render, staticRenderFns } from "./SenaEditionAddUpdate.vue?vue&type=template&id=7229e83b&"
import script from "./SenaEditionAddUpdate.vue?vue&type=script&lang=js&"
export * from "./SenaEditionAddUpdate.vue?vue&type=script&lang=js&"
import style0 from "./SenaEditionAddUpdate.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports